import { useToast } from './use-toast';
import { captureException } from '@/integrations/sentry/client';

interface ErrorHandlerOptions {
  showToast?: boolean;
  toastTitle?: string;
  toastMessage?: string;
  context?: Record<string, any>;
}

/**
 * Custom hook for handling errors with Sentry integration
 */
export const useErrorHandler = () => {
  const { toast } = useToast();

  /**
   * Handle errors with optional Sentry tracking and toast notification
   */
  const handleError = (
    error: unknown, 
    options: ErrorHandlerOptions = { 
      showToast: true,
      toastTitle: 'Error',
      toastMessage: 'Something went wrong. Please try again later.',
    }
  ) => {
    console.error('Error caught:', error);
    
    // Capture the error in Sentry with context
    captureException(error, options.context);
    
    // Show toast notification if enabled
    if (options.showToast) {
      toast({
        title: options.toastTitle || 'Error',
        description: options.toastMessage || 'Something went wrong. Please try again later.',
        variant: 'destructive',
      });
    }
    
    return error;
  };

  return { handleError };
};
